import React from 'react'
import { IconsModel } from './iconsModel'

const SvgPoint = (
	{
		color = '#00B5AE',
		width = 20,
		height = 20
	}: IconsModel
) => (
	<svg width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M30 15C30 6.7157 23.2843 0 15 0C6.71573 0 0 6.7157 0 15C0 23.2842 6.71573 30 15 30C23.2843 30 30 23.2842 30 15Z" fill={color} />
	</svg>
)

export default SvgPoint
